import styled from "styled-components";

export const ProfileMobileFilterWrapper = styled.div`
  display: none;
  margin-top: 40px;
  @media (max-width: 767.98px) {
    display: block;
  }
`;
